//TODO 暂时配置在此,3.5.0迁移到客制化
import appUtils from '../../app/lib/appUtil';
const sdkConfigUrl = `//${appUtils.getImgcacheUrl()}/customize/cache/js/sdk-router-by-tce.js`;

async function getConfig(sdkName) {
    await loadConfig();
    var buffetSdkRouter = window.__sdkRouterByTce;
    if (buffetSdkRouter) {
        return buffetSdkRouter[sdkName];
    }
    return {};
}

function loadConfig() {
    return new Promise(function (resolve, rejectPromise) {
        if (window.__sdkRouterByTce) {
            resolve();
        } else {
            window.seajs.use([sdkConfigUrl], (data) => {
                resolve();
            });
        }

    });

}
export { getConfig, loadConfig };